import type { ComponentProps } from 'react';
import { cva, cx, type VariantProps } from '@/cva.config';

export const textAreaVariants = cva({
  base: [
    'w-full rounded-md border border-border bg-surface/60 px-3 py-2.5 text-foreground transition-colors placeholder:text-foreground-muted/40',
  ],
  defaultVariants: {
    resize: false,
    size: 'md',
    variant: 'primary',
  },
  variants: {
    resize: {
      false: 'resize-none',
      true: 'resize-y',
    },
    size: {
      lg: 'text-base/relaxed lg:text-base/relaxed',
      md: 'text-base/relaxed lg:text-base/relaxed',
      sm: 'text-sm/relaxed lg:text-sm/relaxed',
    },
    variant: {
      primary: [
        'bg-accent/15 text-accent hover:bg-accent/25 hover:shadow-sm hover:shadow-accent/10 focus:border-accent/40 focus:outline-none',
      ],
    },
  },
});

interface TextAreaProps
  extends VariantProps<typeof textAreaVariants>,
    ComponentProps<'textarea'> {}

export const TextArea = ({
  className,
  resize,
  size,
  variant,
  ...props
}: TextAreaProps) =>
  resize ? (
    <div className="relative">
      <textarea
        className={cx(
          textAreaVariants({ resize, size, variant }),
          'pb-5',
          className,
        )}
        {...props}
      />
      <div className="pointer-events-none absolute right-2 bottom-2 flex gap-px opacity-40">
        <svg
          className="text-current"
          height="10"
          viewBox="0 0 10 10"
          width="10"
        >
          <title>Resize handle</title>
          <line
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
            x1="9"
            x2="1"
            y1="1"
            y2="9"
          />
          <line
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
            x1="9"
            x2="5"
            y1="5"
            y2="9"
          />
        </svg>
      </div>
    </div>
  ) : (
    <textarea
      className={cx(textAreaVariants({ resize, size, variant }), className)}
      {...props}
    />
  );
